export default __webpack_public_path__ + "static/media/introduce_yourself2.089710fa.svg";